export var WORLD_ENDPOINTS;
(function (WORLD_ENDPOINTS) {
    WORLD_ENDPOINTS["SMAVA_ROOT"] = "https://smava.de";
})(WORLD_ENDPOINTS || (WORLD_ENDPOINTS = {}));
